import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

export default function BillingCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { refresh } = useWorkspace();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Ödemeniz doğrulanıyor...');

  useEffect(() => {
    const token = params.get('token');
    const conversationId = params.get('conversationId') || params.get('conversation_id');
    if (!token && !conversationId) {
      setStatus('error');
      setMessage('Geçersiz callback parametreleri.');
      return;
    }
    (async () => {
      try {
        const response = await axios.post(`${API}/billing/callback`, { token, conversationId });
        if (response.data?.status === 'success') {
          setStatus('success');
          setMessage('Ödemeniz başarıyla alındı. Aboneliğiniz aktif.');
          await refresh();
          setTimeout(() => navigate('/settings/billing'), 2000);
        } else {
          setStatus('error');
          setMessage(response.data?.message || 'Ödeme tamamlanamadı.');
        }
      } catch (err) {
        setStatus('error');
        const detail = err.response?.data?.detail;
        setMessage(typeof detail === 'string' ? detail : (detail?.message || 'Ödeme doğrulanamadı.'));
      }
    })();
  }, [params, navigate, refresh]);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--surface-muted)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div className="ox-surface rounded-md" style={{ padding: 32, width: 'min(420px, 96vw)', textAlign: 'center' }}>
        {status === 'processing' && (
          <div className="flex flex-col items-center gap-3 ox-text-muted">
            <Loader2 className="animate-spin" size={28} />
            <div className="text-[15px] font-semibold" style={{ color: 'var(--text)' }}>Ödeme İşleniyor</div>
            <div className="text-[13px]">{message}</div>
          </div>
        )}
        {status === 'success' && (
          <div className="flex flex-col items-center gap-3">
            <CheckCircle size={36} style={{ color: 'var(--good)' }} />
            <div className="text-[16px] font-semibold">Ödeme Başarılı</div>
            <div className="text-[13px] ox-text-muted">{message}</div>
            <button onClick={() => navigate('/settings/billing')} className="ox-btn ox-btn-primary mt-2">Faturalandırmaya Git</button>
          </div>
        )}
        {status === 'error' && (
          <div className="flex flex-col items-center gap-3">
            <XCircle size={36} style={{ color: 'var(--danger)' }} />
            <div className="text-[16px] font-semibold">Ödeme Başarısız</div>
            <div className="text-[13px] ox-text-muted">{message}</div>
            <div className="flex gap-2 mt-2">
              <button onClick={() => navigate('/pricing')} className="ox-btn">Tekrar Dene</button>
              <button onClick={() => navigate('/dashboard')} className="ox-btn">Dashboard'a Dön</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
